import { render, staticRenderFns } from "./FormMaterialCategory.vue?vue&type=template&id=349861ff"
import script from "./FormMaterialCategory.vue?vue&type=script&lang=js"
export * from "./FormMaterialCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports